"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * E-Verify Account Service
 * API for management of E-Verify Accounts
 *
 * The version of the OpenAPI document: 1.0.133
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublishStatusToJSON = exports.PublishStatusFromJSONTyped = exports.PublishStatusFromJSON = exports.PublishStatus = void 0;
/**
 * The publish statuses for publish to Kafka endpoint
 * @export
 * @enum {string}
 */
var PublishStatus;
(function (PublishStatus) {
    PublishStatus["SUCCESS"] = "SUCCESS";
    PublishStatus["FAIL"] = "FAIL";
    PublishStatus["NOTFOUND"] = "NOT_FOUND";
})(PublishStatus = exports.PublishStatus || (exports.PublishStatus = {}));
function PublishStatusFromJSON(json) {
    return PublishStatusFromJSONTyped(json, false);
}
exports.PublishStatusFromJSON = PublishStatusFromJSON;
function PublishStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.PublishStatusFromJSONTyped = PublishStatusFromJSONTyped;
function PublishStatusToJSON(value) {
    return value;
}
exports.PublishStatusToJSON = PublishStatusToJSON;
